import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as RoutingActions } from '../constants/RoutingConstants';
import { actions as AuthActions } from '../constants/AuthConstants';
import { actions as GuestListActions } from '../constants/GuestListConstants';
import { actions as GuestActions } from '../constants/GuestConstants';
import { actions as UserActions } from '../constants/UserConstants';

import UserStore from '../stores/UserStore';

import { events as RoutingEvents } from '../constants/RoutingConstants';
import PosCartActions from '../actions/PosCartActions';

var _state = {
    history : []
}

class RoutingStoreClass extends EventEmitter {

    getRoute() {
        if (_state.history.length === 0)
            return '';

        return _state.history[_state.history.length - 1];
    }

    addPageToHistory(url) {
        if (!url)
            url = this.getLastRoute();

        if (url.length === 0)
            url = 'main-menu';
            
        url = this.spliceUrl(url);

        this.updateRoute(url);
    }

    updateRoute(url) {
        _state.history.push(url);



        this.emitChange();
    }

    spliceUrl(url) {
        var parts = url.split('/');

        for (var i=parts.length - 1; i>=0; i--) {
            if (parts[i] === '')
                parts.splice(i, 1);
            else
                parts[i] = parts[i].toLowerCase();
        }

        return parts;
    }

    getLastRoute() {
        if (_state.history.length === 0)
            return '';

        var route = '';
        var last_route = _state.history[_state.history.length - 1];
        for (var i=0; i<last_route.length; i++) {
            route = route+'/'+last_route[i];
        }

        return route;
    }

    getLastRouteArr() {
        if (_state.history.length === 0)
            return ['main-menu'];

        return _state.history[_state.history.length - 1];
    }

    emitChange( callback ) {
        this.emit(RoutingEvents.CHANGE_EVENT, callback)
    }

    addChangeListener( callback ) {
        this.on(RoutingEvents.CHANGE_EVENT, callback)
    }

    removeChangeListener( callback ) {
        this.removeListener(RoutingEvents.CHANGE_EVENT, callback)
    }
}

const RoutingStore = new RoutingStoreClass();

RoutingStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {

        case RoutingActions.UPDATE_ROUTE:
            RoutingStore.addPageToHistory(action.url);
            
            if(UserStore.getState().selectedLocation.UseCartDisplay) {
                PosCartActions.clearCartDisplay();
            }

            break;

        case AuthActions.LOGIN:
            if (!action.data)
                return;

            if(window.location.href.indexOf('cart-display') >= 0) {
                RoutingStore.addPageToHistory('cart-display');
                var slashIndex = window.location.href.lastIndexOf('-');
                UserStore.setRegister(window.location.href.slice(slashIndex + 1));
            } else {
                RoutingStore.addPageToHistory('guest-list');
            }
            break;

        case GuestListActions.GUEST_CHECKED_OUT:
            RoutingStore.addPageToHistory('guest-list');
            break;

        case RoutingActions.BACK:
            _state.history.splice(-1, 1);
            RoutingStore.addPageToHistory(false);
            break;

        case GuestActions.GUEST_LOAD_FAIL:
            if (RoutingStore.getLastRouteArr[0] === 'pos')
                RoutingStore.addPageToHistory('guest-list');
            break;
    }
});

export default RoutingStore



// WEBPACK FOOTER //
// ./ui_src/app/stores/RoutingStore.jsx